import Logger from '../logger';

import has from 'lodash/has';
import assign from 'lodash/assign';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import cloneDeep from 'lodash/cloneDeep';

const localStorage = window.localStorage;
const logger = new Logger('StorageHelper');

const _cache = {};

class StorageHelper {
   set(groupName, key, value) {
      try {
         value = _safer(value);
         let group = _getGroup(groupName);
         let data = group[key];
         if ( isObject(data) && isObject(value) && !isArray(data) ) {
            group[key] = assign(data, value);
         } else {
            group[key] = value;
         }

         localStorage.setItem(groupName, JSON.stringify(group));
      } catch(e) {
         logger.error('error on set data to localStorage', e);
      }
   }
   get(groupName, key) {
      let res = _getGroup(groupName)[key];
      return _safer(res);
   }
   remove(groupName, key) {
      this.set(groupName, key, null);
   }
}

export default new StorageHelper();

function _getGroup(name) {
   if ( has(_cache, name) ) {
      return _cache[name];
   }

   let stored = localStorage.getItem(name);
   if (stored) {
      try {
         stored = JSON.parse(stored);
      } catch(e) {
         logger.error('error on parse stored json', e);
         stored = {};
      }
   } else {
      stored = {};
   }

   _cache[name] = stored;

   return stored;
}

function _safer(val) {
   if ( isObject(val) || isArray(val) ) {
      val = cloneDeep(val);
   }
   return val;
}
